// @flow

import React, { Fragment } from "react";
import { Row, Col } from "../../..";
import { Column } from "../column";
import type { ColumnType } from "../../types";

type Props = {|
  column: ColumnType,
|};

export const SubColumns = (props: Props) => (
  <Fragment>
    <Column column={props.column} />
    {/* rows of data */}
    <Row noGutters={true}>
      {props.column.data.map((keyValue, index) => (
        <Col
          xs={props.column.subColumns ? 12 / props.column.subColumns : null}
          key={`subColumn-${index}`}
        >
          <hr className="my-2" />
          <div className="pb-1 row-label">{keyValue[0]}</div>
          <div className="row-value">{keyValue[1]}</div>
        </Col>
      ))}
    </Row>
  </Fragment>
);

export default SubColumns;
